// extracted by mini-css-extract-plugin
export var inputContainer = "_tc-0";